export default {
  install(app) {
    app.directive("long-press", {
      mounted(el, binding) {
        let pressTimer = null;
        let startHandler, moveHandler, endHandler, cancelHandler;

        // 触摸开始处理
        startHandler = (e) => {
          // 点击的是 a 标签时不阻止默认行为（允许链接跳转）
          if (e.target.closest('a')) return;

          // 不能调用 e.preventDefault()：touchstart 的默认行为被取消后，
          // 从气泡上开始的滑动将无法传递到滚动容器（.box-bd），导致页面滑不动
          if (pressTimer === null) {
            pressTimer = setTimeout(() => {
              if (typeof binding.value === "function") {
                binding.value(true, e);
              }
            }, 500);
          }
        };

        // 触摸移动时取消长按（用户可能是在滚动）
        moveHandler = () => {
          clearTimeout(pressTimer);
          pressTimer = null;
        };

        // 触摸结束处理
        endHandler = (e) => {
          binding.value(false, e);
          clearTimeout(pressTimer);
          pressTimer = null;
        };

        // 触摸取消处理
        cancelHandler = () => {
          clearTimeout(pressTimer);
          pressTimer = null;
        };

        // 添加事件监听（passive 保证滚动不被阻塞）
        el.addEventListener("touchstart", startHandler, { passive: true });
        el.addEventListener("touchmove", moveHandler, { passive: true });
        el.addEventListener("touchend", endHandler, { passive: true });
        el.addEventListener("touchcancel", cancelHandler, { passive: true });

        // 保存处理函数以便卸载
        el._longPressHandlers = { startHandler, moveHandler, endHandler, cancelHandler };
      },
      unmounted(el) {
        // 移除事件监听
        const { startHandler, moveHandler, endHandler, cancelHandler } = el._longPressHandlers || {};
        el.removeEventListener("touchstart", startHandler);
        el.removeEventListener("touchmove", moveHandler);
        el.removeEventListener("touchend", endHandler);
        el.removeEventListener("touchcancel", cancelHandler);
      }
    });
  }
};